import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';
import Modal from '../common/Modal/Modal';
import '../../styles/insightCards.css';
import './RiskPolicyMatrix.css';

interface RiskPolicyMatrixData {
  stockSlug?: string | null;
}

const PDF_URLS: Record<string, string> = {
  redfish: '/acadian-redfish-risk-policy-matrix.pdf',
};

const TITLES: Record<string, string> = {
  redfish: 'Acadian Redfish Risk Policy Matrix',
};

export default function RiskPolicyMatrix(
  props: RegistryComponentProps
): React.ReactElement {
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<RiskPolicyMatrixData>(props);
  const [showModal, setShowModal] = useState(false);

  const pageStockSlug = pageData?.data?.stockSlug as string | undefined;
  const isWhamCompatibleStock = pageData?.data?.isWhamCompatibleStock as boolean | undefined;
  const stockSlug = data.stockSlug ?? pageStockSlug ?? null;

  const canShow = Boolean(isWhamCompatibleStock) && stockSlug === 'redfish';

  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  if (!canShow) return <></>;

  const pdfUrl = stockSlug ? PDF_URLS[stockSlug] : '';
  const title = stockSlug ? TITLES[stockSlug] : 'Risk Policy Matrix';

  return (
    <div className="risk-policy-matrix insight-card">
      <div className="insight-title-row">
        <h3 className="insight-title">Risk Policy Matrix</h3>
      </div>
      <div className="insight-columns">
        <button
          type="button"
          className="insight-column clickable-column"
          style={{ marginRight: 0, cursor: 'pointer', minHeight: '40px' }}
          onClick={() => setShowModal(true)}
        >
          View Risk Policy Matrix
        </button>
      </div>

      {showModal &&
        pdfUrl &&
        createPortal(
          <Modal
            title={title}
            onClose={handleCloseModal}
            size="extra-large"
            transparentBackdrop={true}
            parameterStyle={true}
            {...({ customMaxWidth: '95vw', customMaxHeight: '90vh' } as Record<string, unknown>)}
            bodyStyle={{ padding: '0', height: '100%', overflow: 'hidden' }}
          >
            <iframe
              src={pdfUrl}
              style={{
                width: '100%',
                height: '100%',
                minHeight: '80vh',
                border: 'none',
              }}
              title={title}
            />
          </Modal>,
          document.body
        )}
    </div>
  );
}
